import React from "react";

const LOGO_BADGE_URL = "/logo-badge.png";
const LOGO_LIGHT_URL = "/logo-light.png";

// Light lockup — cream/green/blue version for dark hero sections.
export const LogoFull = ({ size = 340, className = "" }) => (
  <img
    src={LOGO_LIGHT_URL}
    width={size}
    alt="Dillpickle's Carwash — full logo"
    className={className}
    style={{ width: size, height: "auto", objectFit: "contain" }}
    draggable={false}
  />
);

// Wordmark — original logo colors on a cream badge (sticker style).
export const LogoWordmark = ({ className = "" }) => (
  <div
    className={`inline-flex items-center bg-[#FDFDFB] rounded-2xl px-3 py-1.5 shadow-[0_4px_14px_rgba(0,0,0,0.35)] ${className}`}
    data-testid="brand-logo"
  >
    <img
      src={LOGO_BADGE_URL}
      height={38}
      alt="Dillpickle's Carwash logo"
      style={{ height: 38, width: "auto", objectFit: "contain" }}
      draggable={false}
    />
  </div>
);

export default LogoWordmark;
